"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localStorageAdapter = exports.cookieStorageAdapter = void 0;

var _util = require("./util");

/**
 * Stores values in cookies
 * @param options
 */
var cookieStorageAdapter = function cookieStorageAdapter(options) {
  return {
    get: _util.getCookie,
    set: function set(name, value) {
      (0, _util.setCookie)(name, value, (options.lifetime || 31536000) * 1000, options.path || '/');
    },
    remove: function remove(name) {
      (0, _util.setCookie)(name, '', -999999, options.path || '/');
    }
  };
};
/**
 * Stores values in the localstorage
 */


exports.cookieStorageAdapter = cookieStorageAdapter;

var localStorageAdapter = function localStorageAdapter() {
  return {
    get: function get(name) {
      return window.localStorage.getItem(name);
    },
    set: function set(name, value) {
      return window.localStorage.setItem(name, value);
    },
    remove: function remove(name) {
      return window.localStorage.removeItem(name);
    }
  };
};

exports.localStorageAdapter = localStorageAdapter;